import { render, staticRenderFns } from "./update-job-order.vue?vue&type=template&id=4b25ec3e"
import script from "./update-job-order.vue?vue&type=script&lang=js"
export * from "./update-job-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports